<script>
    import axios from 'axios'
    import { http } from '../../http';
    import { insertQueryParam } from 'App/helpers';
    import union from 'lodash/union';
    import { createApp } from 'vue';
    import Avatar from '../../components/global/Avatar.vue';
    import forEach from 'lodash/forEach';
    import includes from 'lodash/includes';
    import remove from 'lodash/remove';
    import eventService from '../events/eventService.js';
    import Apps from '../../../core/Apps';
    import MoveRecurringBookingModal from './MoveRecurringBookingModal';
    import Flatpickr from 'flatpickr';
    import isDark from 'chromatic-luminance';
    import moment from 'moment';
    import CalendarDropdownActions from './CalendarDropdownActions.vue';
    import ClientBookingDropdownActions from './ClientBookingDropdownActions.vue';
    import FloatableDropdown from './FloatableDropdown.vue';
    import ClientJournal from '../client/ClientJournal.vue';
    import Modal from '@/system/components/global/Modal';
    import printHtmlMixin from '@/system/helpers/printHtml';
    import BookingStatusSettings from 'Modules/AppointmentStatus/resources/js/BookingStatusSettings.vue';
    import swal from 'sweetalert';
    import { patientTravelMixin } from 'PatientTravel/components/shared/Mixins';
    import TeamMeetingFormModal from '@/system/components/apps/team_meetings/TeamMeetingFormModal';
    import TeamMeetingDetailModal from '@/system/components/apps/team_meetings/TeamMeetingDetailModal';
    import RecurringTeamMeetingAdjustmentModal from '@/system/components/apps/team_meetings/RecurringTeamMeetingAdjustmentModal';
    import { moveTeamMeetingRequest } from '@/system/components/apps/team_meetings/TeamMeetingsService';
    import { moveContactBookingRequest } from '@/system/components/apps/other_payers/bookings/ContactBookingService';
    import ContactBookingDetailModal from '@/system/components/apps/other_payers/bookings/ContactBookingDetailModal';
    import CreateContactBooking from '@/system/components/calendar/CreateContactBooking';
    import RecurringContactBookingAdjustmentModal from '@/system/components/apps/other_payers/bookings/RecurringContactBookingAdjustmentModal';
    import CreateContactBookingNoAccess from '@/system/components/calendar/CreateContactBookingNoAccess.vue';
    import QuickBooking from 'Components/calendar/QuickBookingModal.vue';
    import AddSurveyToBookingModal from 'Components/apps/survey/AddSurveyToBookingModal';
    import { useCalendarSidebarStore, SidebarViews } from 'Components/calendar/calendar_sidebar/store/calendarSidebarStore';
    import { mapStores } from 'pinia';

    var view_type = 'desktop';
    var has_close_book = false;
    var has_bookings = false;
    var last_saved_view = {
        mobile: null,
        desktop: null
    }
    let bookingTypes = [
        'client_booking',
        'other_booking',
        'close_online_booking',
        'recurring_close_online_booking',
        'recurring_other_booking'
    ];

    export default {
        mixins: [printHtmlMixin, patientTravelMixin],

        components: {
            FloatableDropdown,
            CalendarDropdownActions,
            MoveRecurringBookingModal,
            ClientBookingDropdownActions,
            ClientJournal,
            Modal,
            TeamMeetingFormModal,
            TeamMeetingDetailModal,
            RecurringTeamMeetingAdjustmentModal,
            CreateContactBooking,
            CreateContactBookingNoAccess,
            ContactBookingDetailModal,
            RecurringContactBookingAdjustmentModal,
            QuickBooking,
            AddSurveyToBookingModal
        },

        data() {
            return {
                calendar: {},
                active_view : null,
                quick_navigation_datepicker: null,
                edit_closing_times: false,
                publicHoliday: {
                    retrievedYears: [],
                    holidays: []
                },
                copying_booking: false,
                loading: false,
                first_load: true,
                is_blurred: false,
                show_create_modal: this.initial_show_create_modal,
                overlap_slots: true,
                calendar_view_mobile: this.initial_calendar_view_mobile,
                calendar_view_desktop: this.initial_calendar_view_desktop,
                header_buttons_left : [ 'month','agendaWeek','agendaThreeDay','agendaDay'],
                show_cancelled_bookings_on_these_dates : [],
                show_cancelled_bookings_on_these_calendars: [],
                contextMenuProps: {},
                timeoutId: null,
                eventFetchTimer: null,
                cancellationSource: axios.CancelToken.source(),
                teamMeetingsCancellationSource: axios.CancelToken.source(),
                contextMenus: {
                    calendar: 'calendar',
                    clientBooking: 'client_booking'
                },
                selectedContextMenu: null,
                showJournal: false,
                selectedBooking: null,
                bookingsEventSourceUrl: `/app/user/${this.user.id}/bookings?render_close_events_in_background=${(this.edit_closing_times ? '0' : '1')}`,
                teamMeetingEventSource: null,
                showQuickBooking: false,
                quickBookingData: null,
            }
        },

        props: {
            show_holidays: {
                required: true
            },

            show_weekends: {
                required: false,
                default: true
            },

            has_calendar_blocking_rules_created: {
                required: false,
                default: false
            },

            show_timeline: {
                required: true
            },

            initial_calendar_view_mobile: {
                required: true
            },

            initial_calendar_view_desktop: {
                required: true
            },

            calendars_count: {
                required: true
            },

            user: {
                required: true
            },

            has_products_with_colours: {
                default: 1
            },

            initial_show_create_modal: {
                required: false,
                default: false
            },

            should_pull_from_google_calendar: {
                required: false,
                default: false,
            },

            journal_sort_setting: {
                required: true,
            },

            on_tour: {
                type: Boolean,
                required: false,
                default: false,
            },

            calendar_sidebar_enabled: {
                type: Boolean,
                default: false,
            },

            surveySettings: {
                required: false,
                default: null,
            },

            canSendSmsMessages: {
                required: true,
            },
        },

        computed: {
            calendar_interval_label_attribute(){

                if(this.user.calendar_interval == 5){
                    return '00:15:00';
                }

                if(this.user.calendar_interval == 10){
                    return '00:30:00';
                }

                return '00:60:00';

            },

            is_waiting_list_active() {
                return this.$store.getters['apps/isAppEnabled'](Apps.WaitingList);
            },

            is_booking_status_active() {
                return this.$store.getters['apps/isAppEnabled'](Apps.BookingStatus);
            },

            is_events_active() {
                return this.$store.getters['apps/isAppEnabled'](Apps.Events);
            },

            is_team_meetings_active() {
                return this.$store.getters['apps/isAppEnabled'](Apps.TeamMeetings);
            },

            is_other_payers_active() {
                return this.$store.getters['apps/isAppEnabled'](Apps.OtherPayers);
            },

            activeCalendars() {
                return this.$store.getters['calendars/getActiveCalendars']
            },

            activeCalendarsWithWaitingListEnabled(){
                return this.activeCalendars.filter((calendar) => calendar.waiting_list)
            },

            owner() {
                return this.$store.state.auth.owner;
            },

            show_all_day_slot() {
                return this.show_holidays || this.should_pull_from_google_calendar;
            },

            can_edit_calendars() {
                const can_edit = this.$store.getters['calendars/getCalendars']().filter((calendar) => {
                    return calendar.can_edit;
                }).length > 0;

                if (can_edit && this.show_create_modal) {
                    this.show_create_modal = false;
                    this.$nextTick(() => {
                        $('#calendar-actions-btn').dropdown('toggle')
                    });
                }

                return can_edit;
            },

            has_waiting_list() {
                var returnValue = this.is_waiting_list_active
                    && this.$store.getters['calendars/getCalendars']().filter((calendar) => {
                        return calendar.waiting_list;
                    }).length > 0;
                return returnValue;
            },

            bookingIdInURL () {
                return this.getParameterByName('showBooking');
            },

            meetingIdInURL () {
                return this.getParameterByName('showMeeting');
            },

            contactBookingIdInURL () {
                return this.getParameterByName('showContactBooking');
            },

            can_see_clients() {
                return this.$can('see-clients');
            },

            can_see_unassigned_client_names() {
                return this.$store.state.auth.user ? this.$store.state.auth.user.can_see_unassigned_client_names : false
            },

            is_online_booking_active() {
                return this.$store.getters['apps/isAppEnabled'](Apps.OnlineBooking);
            },

            is_surveys_enabled() {
                return this.$store.getters['apps/isAppEnabled'](Apps.Surveys);
            },

            ...mapStores(useCalendarSidebarStore),
        },

        created() {
            if (this.bookingIdInURL) {
                this.fetchBooking(this.bookingIdInURL);
            }

            if (this.meetingIdInURL) {
                this.fetchMeeting(this.meetingIdInURL);
            }

            if (this.contactBookingIdInURL) {
                this.fetchContactBooking(this.contactBookingIdInURL);
            }
        },

        mounted() {
            var vm = this;

            this.$event_bus.$on('calendarReload', (client) => {
                this.reloadCalendar();
                this.addColumnInformationToCalendar();
            });

            this.$event_bus.$on('calendarVisibilityToggled', (client) => {
                this.calendar.fullCalendar('refetchResources');
            });

            this.$event_bus.$on('copyBooking', (booking) => {
                this.copying_booking = booking;
            });


            this.$event_bus.$on('toggleBlur', (is_blurred) => {
                this.is_blurred = is_blurred;
            });

            this.$event_bus.$on('goToCalendarDate', (date) => {
                this.calendar.fullCalendar('gotoDate', date);
            });

            this.$event_bus.$on('editClosingTimes', (edit) => {
                this.edit_closing_times = edit;
                this.updateEventSourceForBookings();
                this.reloadCalendar();
            });

            this.$event_bus.$on('printCalendar', () => {
                this.printCalendar();
            });

            this.$event_bus.$on('renderCalendarEvent', (event) => {
                this.$event_bus.$emit('goToCalendarDate', event.start);
                this.calendar.fullCalendar('renderEvent', event);
            });

            this.$event_bus.$on('removeEvents', (id) => {
                this.calendar.fullCalendar( 'removeEvents', id);
            });

            this.$event_bus.$on('updateCalendarTimeFrame', data => {
                var calendar = this.calendar.fullCalendar('getCalendar');

                if (data.minTime) {
                    calendar.option('minTime', data.minTime);
                }

                if (data.maxTime) {
                    calendar.option('maxTime', data.maxTime);
                }
            });

            if (this.calendar_sidebar_enabled) {
                this.$event_bus.$on('calendarsLoaded', this.handleCalendarsLoaded);
            }

            if(this.calendars_count > 1) {
                this.header_buttons_left = ['month', 'agendaWeek', 'agendaThreeDay', 'agendaDay', 'resourceView'];
            }

            this.$nextTick(() => {
                let defaultDate = moment();

                if (vm.getParameterByName('setCalendarView') !== '') {
                    defaultDate = moment(vm.getParameterByName('setCalendarView'), 'YYYY-MM-DD');
                }

                // page is now ready, initialize the calendar...
                this.calendar = $('#user-calendar').fullCalendar({
                    header: {
                        left: this.header_buttons_left.join(),
                        center: 'title',
                        right: 'today, prev, next'
                    },
                    plugins: [ 'resourceTimeline' ],
                    schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
                    height :'auto',
                    contentHeight :'auto',
                    selectLongPressDelay : 200,
                    locale : moment_locale == 'en' ? 'en_GB' : moment_locale, //This is a global variable from app.blade.php
                    defaultView: this.getDefaultView(),
                    defaultDate: defaultDate,
                    editable: true,
                    selectable: this.can_edit_calendars,
                    allDayText: '',
                    selectHelper: false,
                    allDaySlot: this.show_all_day_slot,
                    nowIndicator : this.show_timeline,
                    weekends: Boolean(this.show_weekends),
                    weekNumbers: true,
                    eventResourceEditable : false,
                    weekNumbersWithinDays: true,
                    firstDay: 1,
                    views: {
                        agendaThreeDay: {
                            type: 'agenda',
                            dayCount: 3,
                            dateIncrement: { days: 3 },
                            buttonText: trans('calendar.short_agenda_view_label')
                        },
                        agendaDay : {
                            titleFormat : ' ',
                        },
                        resourceView: {
                            type: 'agenda',
                            titleFormat : ' ',
                            buttonText: trans('events.overview'),
                            duration: { days: 1 },
                        },
                    },
                    buttonText: {
                      today: trans('app.today'),
                    },
                    dragScroll : false,
                    minTime: this.user.calendarstarttime,
                    maxTime: this.user.calendarendtime,
                    columnFormat: 'ddd D/M',
                    slotLabelFormat: 'H:mm',
                    timeFormat: 'H:mm',
                    eventColor:"#C3E1FF",
                    slotDuration: '00:'+this.user.calendar_interval+':00',
                    slotLabelInterval : this.calendar_interval_label_attribute,
                    slotEventOverlap: this.user.calendar_overlapping_enabled,
                    events: (start, end, timezone, callback) => {
                        this.eventFetchTimer = clearTimeout(this.eventFetchTimer);
                        this.eventFetchTimer = setTimeout(() => {
                            this.getEvents(start, end, callback);
                        }, 500);
                    },
                    resources: (this.calendar_view_desktop !== 'agendaDay' ? '/app/calendars/as-resources' : false),
                    resourceRender: (resource, $th) => {
                        $th.html(this.sanitizeHtml(resource.title_as_html));

                        const AvatarCtor = createApp(Avatar, {
                            url: resource.profile_image_url,
                            width : '36px',
                            height : '36px',
                            borderColor : resource.color,

                        });

                        AvatarCtor.mount($th.find('.avatar-outer-wrapper')[0]);
                    },
                    windowResize: (view)  => {
                        this.triggerCalendarViewOption();
                    },
                    eventRender: (booking, element) => {
                        has_bookings = true;

                        element.number_of_icons = 0;
                        element.already_has_check_icon = false;

                        if (booking.type === "client_booking") {

                            if (element) {
                                element[0].addEventListener('contextmenu', (jsEvent) => {
                                    jsEvent.preventDefault();
                                    this.selectedContextMenu = this.contextMenus.clientBooking
                                    this.contextMenuProps = { booking }
                                    this.$refs.contextMenu.open(jsEvent)
                                }, false);
                            }

                            this.displayServiceColorsOnCalender(booking, element);

                            if (booking.className.indexOf('invoiced') > -1) {
                                if (booking.className.indexOf('partially_invoiced') > -1) {
                                    this.addIconToEventElement(element, 'zmdi-time-interval');
                                } else if (booking.invoiceline && booking.invoiceline.invoice && booking.invoiceline.invoice.scheduled_invoice) {
                                    if (booking.group_payed) {
                                        this.addIconToEventElement(element, 'zmdi-check');
                                    } else if (booking.className.indexOf('payed') > -1) {
                                        this.addIconToEventElement(element, 'zmdi-time-interval');
                                    } else {
                                        this.addIconToEventElement(element, 'zmdi-time-interval');
                                    }
                                } else {
                                    if (booking.className.indexOf('payed') > -1) {
                                        this.addIconToEventElement(element, 'zmdi-check');
                                    } else {
                                        this.addIconToEventElement(element, 'zmdi-file');
                                    }
                                }
                            } else if (booking.className.indexOf('easypay') > -1) {
                                if (booking.className.indexOf('easypay_failed') > -1) {
                                    this.addIconToEventElement(element, 'zmdi-card');
                                    this.addIconToEventElement(element, 'zmdi-alert-circle');
                                } else {
                                    this.addIconToEventElement(element, 'zmdi-card');
                                    this.addIconToEventElement(element, 'zmdi-time');
                                }
                            } else if (booking.className.indexOf('giftcard') > -1) {
                                if (booking.className.indexOf('partially_paid') > -1) {
                                    this.addIconToEventElement(element, 'zmdi-time-interval');
                                    this.addIconToEventElement(element, 'zmdi-card-giftcard');
                                } else if (booking.className.indexOf('fully_paid') > -1) {
                                    this.addIconToEventElement(element, 'zmdi-check');
                                }
                            }

                            if (booking.want_to_cancel) {
                                this.addIconToEventElement(element, 'zmdi-alert-triangle')
                            }

                            if (this.is_booking_status_active) {
                                const status = Object.values(this.owner.booking_status_app_settings.statuses).find((status) => {
                                    return status.name === booking.status || status.id === parseInt(booking.status)
                                })

                                if (status) {
                                    this.addIconToEventElement(element, status.icon_class, 'fa', status.name);
                                }
                            }
                        }

                        if (booking.type === "event"){
                            this.displayEventColorsOnCalender(booking, element);
                            this.addIconToEventElement(element, 'zmdi-accounts');
                        }

                        if (booking.type === 'team_meeting') {
                            this.adjustMeeting(booking, element);
                            this.addIconToEventElement(element, 'fa-regular fa-building', 'fa');
                        }

                        if (booking.type === 'contact_booking') {
                            this.adjustMeeting(booking, element);
                            this.addIconToEventElement(element, 'fa-regular fa-id-badge', 'fa');
                            if (booking.className.indexOf('invoiced') > -1) {
                                this.addInvoiceIconsToContactBooking(booking, element);
                            }
                        }

                        if (booking.type === 'blocked_cal_event') {
                            this.addIconToEventElement(element, 'fa-regular fa-calendar-circle-minus', 'fa');
                        }

                        if (booking.type === "recurring_close_online_booking" || booking.type === 'recurring_other_booking') {
                            has_close_book = true;
                            this.addIconToEventElement(element, 'zmdi-repeat');
                        }

                        if (booking.type === 'close_online_booking'){
                            has_close_book = true;
                        }

                        if (booking.type === 'waiting_list_invitation') {
                            const spanElement = document.createElement('span');
                            spanElement.className = 'waiting-list-invitation-title';

                            const iconElement = document.createElement('i');
                            iconElement.className = 'zmdi zmdi-time m-r-5';
                            spanElement.appendChild(iconElement);

                            const textNode = document.createTextNode(booking.title);
                            spanElement.appendChild(textNode);

                            element.append(spanElement);
                        }

                        if (booking.has_notes) {
                            this.addIconToEventElement(element, 'zmdi-comment')
                        }

                        if (booking.type === 'gcal' && booking.isFree) {
                            this.addIconToEventElement(element, 'fa-regular fa-calendar-exclamation', 'fa');
                        }

                        if (this.isPatientTravelActive) {
                            this.indicatePatientTravelInfo(booking, element)
                        }

                        const birthday = (booking.client && booking.client.birthday) ? '<i class="zmdi zmdi-card-giftcard m-r-5"></i>' : '';

                        element.find('.fc-title').html(this.sanitizeHtml(birthday + element.find('.fc-title').text()));
                        element.find('.fc-practitioners').appendTo(element.find('.fc-content'));

                        this.adjustTextColorsToBackground(booking, element);

                    },
                    eventAfterAllRender : (view) => {
                        // Check for close online booking events in all fetched events
                        // This ensures has_close_book is set even if these events aren't rendered in month view
                        let allEvents = vm.calendar.fullCalendar('clientEvents');
                        let hasCloseBookingEvents = allEvents.some(event => 
                            event.type === 'close_online_booking' || event.type === 'recurring_close_online_booking'
                        );
                        
                        if (hasCloseBookingEvents) {
                            has_close_book = true;
                        }

                        if(has_close_book){
                            vm.$event_bus.$emit('showEditCloseEventsButton');
                        }else{
                            vm.$event_bus.$emit('hideEditCloseEventsButton');
                        }
                        if(has_bookings){
                            vm.$event_bus.$emit('showPrintBookingsButton');
                        }else{
                            vm.$event_bus.$emit('hidePrintBookingsButton');
                        }

                        vm.$nextTick(() => {
                            let bookings = vm.calendar.fullCalendar('clientEvents');

                            forEach(bookings, (booking) => {

                                if(booking.type && booking.type === 'client_booking' && booking.status !== 'cancelled'){
                                    if(view.type === 'resourceView'){
                                        $('.calendar .fc-resource-cell[data-resource-id="'+booking.calendar_id+'"] .calendar-column-dropdown:hidden').show();
                                    }else{
                                        $('.calendar .fc-widget-header[data-date="'+booking.start.format('YYYY-MM-DD')+'"] .calendar-column-dropdown:hidden').show();
                                    }
                                }

                            });
                        });

                        //Reset quick navigation calendar date view
                        if(this.quick_navigation_datepicker){
                          this.quick_navigation_datepicker.jumpToDate(view.start.toDate());
                        }

                        const bookingId = this.getActiveBookingId();
                        if (bookingId) {
                            this.highlightActiveBooking(bookingId);
                        }
                    },
                    viewRender: (view) => {

                        this.active_view = view.name;

                        if(vm.first_load){
                            vm.$nextTick(function(){
                                if(vm.getParameterByName('setCalendarView') !== ''){
                                    var goto_date = moment(vm.getParameterByName('setCalendarView'), 'YYYY-MM-DD');
                                    vm.$event_bus.$emit('goToCalendarDate', goto_date);
                                }
                                vm.first_load = false;
                            });
                        }

                        vm.show_cancelled_bookings_on_these_dates = [];
                        vm.show_cancelled_bookings_on_these_calendars = [];
                        vm.updateEventSourceForBookings();

                        vm.$nextTick(() => {
                            if (view.name === 'agendaDay' && vm.calendar.fullCalendar('option', 'resources')) {
                                vm.calendar.fullCalendar('option', 'resources', false);
                            } else if (view.name === 'resourceView' && !vm.calendar.fullCalendar('option', 'resources')) {
                                vm.calendar.fullCalendar('option', 'resources', '/app/calendars/as-resources');
                                vm.calendar.fullCalendar('refetchResources');
                            }

                            vm.saveCalendarViewSetting(view.name);
                            vm.addColumnInformationToCalendar();
                            vm.addColumnMenuItemsToCalender(view);
                            let view_date = view.start.format('YYYY-MM-DD');

                            if (view.name === 'month' && view_date !== view.calendar.currentDate.format('YYYY-MM-DD')) {
                                view_date = view.calendar.currentDate.format('YYYY-MM-DD');
                            }

                            insertQueryParam('setCalendarView', view_date);


                        });

                        if(view.type === 'resourceView' || view.type === 'agendaDay'){
                            $(".fc-header-toolbar .fc-center h2").text(view.start.format('dddd LL'));
                        }

                        if(!$("#quick-calendar-navigation").length){
                          this.mountQuickNavigationCalendar();
                        }

                        if (this.is_team_meetings_active) {
                            this.addTeamMeetingEventSource()
                            this.handleActiveViewForTeamMeetings(view.type)
                        }
                    },
                    select: ( start, end, jsEvent, view, resource ) => {
                        if (this.copying_booking) {

                            //Get timediff
                            var copying_booking_start_object = moment(this.copying_booking.start);
                            var copying_booking_end_object = moment(this.copying_booking.end);
                            var timeDiffms = copying_booking_end_object.diff(copying_booking_start_object);

                            this.copying_booking.id = null;
                            this.copying_booking.start = start.format('YYYY-MM-DD HH:mm')
                            this.copying_booking.end = start.add(timeDiffms, 'milliseconds').format('YYYY-MM-DD HH:mm');
                            // Booking products should be updatable even if the original booking is already invoiced
                            this.copying_booking.booking_products = this.copying_booking.booking_products.map(bp => {
                                return {
                                    ...bp,
                                    can_update: true,
                                    addons: bp.addons.map(addon => {
                                        return {
                                            ...addon,
                                            can_update: true
                                        }
                                    })
                                }
                            })

                            this.$nextTick( () => {
                                if (this.calendar_sidebar_enabled) {
                                    this.calendarSidebarStore.navigateTo(SidebarViews.CREATE_CLIENT_BOOKING, { booking: this.copying_booking, mode: 'edit' });
                                } else {
                                    this.$event_bus.$emit('showEditClientBooking', this.copying_booking);
                                }
                                this.copying_booking = false
                            });

                        } else {
                            this.selectedContextMenu = this.contextMenus.calendar
                            this.contextMenuProps = {
                                selectedStart: start,
                                selectedEnd: view.name === 'month' ? start : end,
                                timeSelected: true,
                                selectedCalendar: resource ? resource.id : null,
                            }

                            if (this.timeoutId) clearTimeout(this.timeoutId);

                            this.timeoutId = setTimeout(() => {
                                this.$refs.contextMenu.open(jsEvent)
                            });
                        }

                        if(this.is_waiting_list_active){
                            this.$event_bus.$emit('resetInvites');
                        }

                    },
                    eventClick: (booking, jsEvent, view) => {
                        switch (booking.type) {
                            case 'client_booking':
                                if (this.calendar_sidebar_enabled) {
                                    this.calendarSidebarStore.navigateTo(SidebarViews.CLIENT_BOOKING, { bookingId: booking.id });
                                } else {
                                    this.$event_bus.$emit('showClientBooking', booking);
                                }
                                break;
                            case 'event':
                                if (booking.event_group_id || booking.event_group) {
                                    this.$event_bus.$emit('showEventSession', booking);
                                } else {
                                    this.$event_bus.$emit('showEvent', booking);
                                }
                                break;
                            case 'blocked_cal_event':
                                this.$event_bus.$emit('showBlockedCalendarEventModal', booking);
                                break;
                            case 'other_booking':
                                if (this.calendar_sidebar_enabled) {
                                    this.calendarSidebarStore.navigateTo(SidebarViews.OTHER_BOOKING, { booking });
                                } else {
                                    this.$event_bus.$emit('showOtherBooking', booking, true);
                                }
                                break;
                            case 'close_online_booking':
                                this.$event_bus.$emit('showCloseBooking', booking, true);
                                break;
                            case 'recurring_close_online_booking':
                                if (this.calendar_sidebar_enabled) {
                                    this.calendarSidebarStore.navigateTo(SidebarViews.RECURRING_OTHER_BOOKING, { booking });
                                } else {
                                    this.$event_bus.$emit('showRecurringCloseBooking', booking, true);
                                }
                                break;
                            case 'recurring_other_booking':
                                if (this.calendar_sidebar_enabled) {
                                    this.calendarSidebarStore.navigateTo(SidebarViews.RECURRING_OTHER_BOOKING, { booking });
                                } else {
                                    this.$event_bus.$emit('showRecurringCloseBooking', booking, true);
                                }
                                break;
                            case 'team_meeting':
                                this.$event_bus.$emit('showTeamMeetingModal', booking);
                                break;
                            case 'contact_booking':
                                this.$event_bus.$emit('showContactBookingModal', booking);
                                break;
                        }
                    },
                    eventDrop: (booking, delta, revertFunc) => {
                        // skip confirmation, there will be a modal pop up anyway
                        if (booking.recurring_booking_group_id && bookingTypes.includes(booking.type)) {
                            return this.moveBooking(booking, revertFunc);
                        } else if (booking.recurring && booking.type === 'team_meeting') {
                            return this.moveTeamMeeting(booking, revertFunc);
                        } else if (booking.recurring && booking.type === 'contact_booking') {
                            return this.moveContactBooking(booking, revertFunc);
                        }

                        swal({
                            title: trans('calendar.update_calendar_confirm_title'),
                            text: trans('calendar.update_calendar_confirm_description'),
                            showCancelButton: true,
                            html: true,
                            cancelButtonText: trans('global.cancel'),
                            showLoaderOnConfirm: true,
                            closeOnConfirm: false,
                        }, (confirm) => {
                            if (confirm) {
                                if (bookingTypes.includes(booking.type)) {
                                    this.moveBooking(booking, revertFunc);
                                } else if (booking.type === 'team_meeting') {
                                    this.moveTeamMeeting(booking, revertFunc);
                                } else if (booking.type === 'contact_booking') {
                                    this.moveContactBooking(booking, revertFunc);
                                } else {
                                    this.moveEvent(booking, false);
                                }
                            } else {
                                revertFunc();
                            }

                            this.loading = false;
                            swal.close();
                        });
                    },

                    eventResize: (booking, delta, revertFunc) => {
                        /**
                         ** TODO: IGN-
                         ** For now, I am keeping the behaviour similar to bookings and events for team meetings.
                         ** but confirm if there is a reason we are not using the swal here when the event the booking is resized.
                         */

                        if (bookingTypes.includes(booking.type)) {
                            this.moveBooking(booking, revertFunc);
                        } else if (booking.type === 'team_meeting') {
                            this.moveTeamMeeting(booking, revertFunc);
                        } else if (booking.type === 'contact_booking') {
                            this.moveContactBooking(booking, revertFunc);
                        } else {
                            this.moveEvent(booking, false);
                        }
                    },
                });
            });
        },

        methods: {
            async fetchTeamMeetings(start, end, _, callback) {
                const params = {
                    start: start.format('YYYY-MM-DD'),
                    end: end.format('YYYY-MM-DD'),
                    active_view: this.currentViewType,
                };

                this.teamMeetingsCancellationSource.cancel();
                this.teamMeetingsCancellationSource = axios.CancelToken.source();

                try {
                    const { data } = await http.get('/app/team-meetings/meetings', { params, cancelToken:this.teamMeetingsCancellationSource.token })
                    callback(data);
                } catch (error) {
                    if (!axios.isCancel(error)) {
                        this.handleEventSourceError(error);
                    }
                }
            },

            openQuickBooking() {
                this.showQuickBooking = true;
                this.quickBookingData = this.copying_booking; // Store copied_booking in data
                this.copying_booking = false; // Close the transition element
            },

            handleActiveViewForTeamMeetings (viewType) {
                const previousViewType = this.currentViewType;
                this.currentViewType = viewType;

                if (
                    (previousViewType !== 'resourceView' && this.currentViewType === 'resourceView') ||
                    (previousViewType === 'resourceView' && this.currentViewType !== 'resourceView')
                ) {
                    this.calendar.fullCalendar('refetchEventSources', 'teamMeetings');
                }
            },

            viewJournal (booking) {
                this.showJournal = true
                this.selectedBooking = booking
            },
            resetContextMenu() {
                this.selectedContextMenu = null
                this.contextMenuProps = {}
            },
            openBookingModal (booking) {
                if (!booking) return

                // HACK! This should be completely refactored
                if (booking.other) {
                    this.$nextTick(() => {
                        this.$event_bus.$emit('showOtherBooking', booking);
                    });
                    return;
                }

                if (booking.type === 'client_booking') {
                    this.$nextTick(() => {
                        if (this.calendar_sidebar_enabled) {
                            this.calendarSidebarStore.navigateTo(SidebarViews.CLIENT_BOOKING, { bookingId: booking.id });
                        } else {
                            this.$event_bus.$emit('showClientBooking', booking);
                        }
                    });
                    return;
                }

                const isEvent = booking.type === 'event';
                const isEventGroup = booking.event_group_id || booking.event_group

                if (!isEvent) return

                if (isEventGroup) {
                    this.$event_bus.$emit('showEventSession', booking);
                } else {
                    this.$event_bus.$emit('showEvent', booking);
                }
            },

            mountQuickNavigationCalendar(){
              $(".fc-header-toolbar .fc-center").after('<div id="quick-calendar-navigation"><i class="zmdi zmdi-chevron-down" data-toggle></i><input type="hidden" data-input></div>');

              var options = {
                wrap : true,
                onChange: (selectedDates, dateStr, instance) => {
                  this.$event_bus.$emit('goToCalendarDate', selectedDates[0]);
                },
                onReady: (selectedDates, dateStr, instance) => {
                  $(instance.calendarContainer).addClass('quick-navigation-picker');
                },
              };

              if (!this.show_weekends) {
                    // Disable weekends
                    options.disable = [(date) => [6, 7].indexOf(this.$filters.isoWeekday(date)) !== -1]
              }

              this.quick_navigation_datepicker = new Flatpickr($("#quick-calendar-navigation")[0], options);
            },

            displayEventColorsOnCalender(booking, element){

                let view = this.calendar.fullCalendar('getView');

                if (!this.user.is_service_color_labels && booking.has_custom_color) {

                    // Display the booking calendar name as a coloured label
                    if (view.type !== 'resourceView' && this.calendars_count !== 1 && booking.color) {
                        const calendarSpanElement = document.createElement('span');

                        const calendarIconElement = document.createElement('i');
                        calendarIconElement.className = 'zmdi zmdi-circle m-r-5';
                        calendarIconElement.style.color = booking.calendar_color;
                        calendarSpanElement.appendChild(calendarIconElement);

                        const calendarTextNode = document.createTextNode(booking.calendar_name);
                        calendarSpanElement.appendChild(calendarTextNode);

                        element.find('.fc-content').append(calendarSpanElement);
                    }
                }
            },

            adjustMeeting(booking, element){
                // booking/meeting/contact appointment
                let view = this.calendar.fullCalendar('getView');
                // wrap the .fc-content in a div with class .fc-content-wrapper
                element.find('.fc-content').wrap('<div class="fc-content-wrapper"></div>');
                // if booking.color is present then we need to show the calendar on which it exits
                if (view.type !== 'resourceView' && this.calendars_count !== 1 && booking.color) {
                    const calendarDivElement = document.createElement('div');
                    calendarDivElement.className = 'fc-calendar';

                    const calendarIconElement = document.createElement('i');
                    calendarIconElement.className = 'zmdi zmdi-circle m-r-5';
                    calendarIconElement.style.color = booking?.calendar?.color;
                    calendarDivElement.appendChild(calendarIconElement);

                    const calendarTextNode = document.createTextNode(booking?.calendar?.name);
                    calendarDivElement.appendChild(calendarTextNode);

                    element.find('.fc-content-wrapper').append(calendarDivElement);
                }
            },

            displayServiceColorsOnCalender(booking, element) {
                let view = this.calendar.fullCalendar('getView');
                let labelFallbackColor = 'rgb(255, 255, 255, 0.6)';
                let firstAvailableColor = false;
                element.find('.fc-content').wrap('<div class="fc-content-wrapper"></div>');

                // We check if we can display service colors as labels or as solid
                if (this.user.is_service_color_labels) {
                    forEach(booking.product_attributes, (product) => {
                        let backgroundColor = labelFallbackColor;
                        let textColor = '#000000';

                        if (product.color) {
                            backgroundColor = product.color;
                            textColor = isDark(product.color) ? '#FFFFFF' : '#000000';
                        }

                        const productSpanElement = document.createElement('span');
                        productSpanElement.className = 'label';
                        productSpanElement.style.backgroundColor = backgroundColor;
                        productSpanElement.style.color = textColor;
                        productSpanElement.textContent = product.name;
                        element.find('.fc-content-wrapper').append(productSpanElement);
                    });
                } else {
                    /*
                    * Here we change the entire colour of the event with the firstAvailableColor if one exists
                    * If one does not exist, the event will continue to use its calendar colour
                    */
                    let textColor = isDark(booking.color) ? '#FFFFFF' : '#000000';

                    forEach(booking.product_attributes, (product) => {
                        if (product.color) {
                            firstAvailableColor = product.color;
                            return false;
                        } else {
                            return true;
                        }
                    });

                    if(booking.product_attributes){
                        const productSpanElement = document.createElement('span');
                        productSpanElement.className = 'fc-products';
                        productSpanElement.textContent = '- ' + booking.product_name;
                        element.find('.fc-content').append(productSpanElement);
                    }

                    if (firstAvailableColor) {
                        element[0]['style']['background-color'] = firstAvailableColor;
                        element[0]['style']['border-top-color'] =  firstAvailableColor;
                        element[0]['style']['border-right-color'] = firstAvailableColor;
                        element[0]['style']['border-bottom-color'] = firstAvailableColor;
                        element[0]['style']['border-left-color'] =  firstAvailableColor;
                    }

                    // Display the booking calendar name as a coloured label
                    if (view.type !== 'resourceView' && this.calendars_count !== 1 && this.has_products_with_colours) {
                        const calendarDivElement = document.createElement('div');
                        calendarDivElement.className = 'fc-calendar';

                        const calendarIconElement = document.createElement('i');
                        calendarIconElement.className = 'zmdi zmdi-circle m-r-5';
                        calendarIconElement.style.color = booking.color;
                        calendarDivElement.appendChild(calendarIconElement);

                        const calendarTextNode = document.createTextNode(booking.calendar_name);
                        calendarDivElement.appendChild(calendarTextNode);

                        element.find('.fc-content-wrapper').append(calendarDivElement);
                    }
                }
            },

            adjustTextColorsToBackground(booking, element) {
                const shouldUseProductColor = !this.user.is_service_color_labels
                    && booking.product_name
                    && booking.type !== 'event'
                    && booking.product_attributes?.length > 0;

                const productColor = shouldUseProductColor && booking.product_attributes[0]?.color;

                const isDarkBg = productColor
                    ? isDark(productColor)
                    : booking.color
                        ? isDark(booking.color)
                        : false;

                if (!isDarkBg || !this.user.is_light_text_on_dark_calendar_events) {
                    element.find('.fc-content div, .fc-content span, .fc-content-wrapper div').css('color', 'black');
                }
            },

            updateEventSourceForBookings() {
                this.bookingsEventSourceUrl = `/app/user/${this.user.id}/bookings?render_close_events_in_background=${(this.edit_closing_times ? '0' : '1')}`;

                if (this.show_cancelled_bookings_on_these_dates.length) {
                    this.bookingsEventSourceUrl += '&show_cancelled_bookings=' + encodeURIComponent(this.show_cancelled_bookings_on_these_dates.toString());
                }

                if (this.show_cancelled_bookings_on_these_calendars.length) {
                    this.bookingsEventSourceUrl += '&show_cancelled_bookings_calendars=' + encodeURIComponent(this.show_cancelled_bookings_on_these_calendars.toString());
                }
            },

            updateEventSourceForBookingBlocking() {
                if (typeof this.calendar.fullCalendar !== 'function') {
                    return;
                }

                if(!this.calendar.fullCalendar('getEventSourceById', 'blocking-bookings-source')){
                    this.calendar.fullCalendar('addEventSource', {
                        url :'/app/user/' + this.user.id + '/blocking-bookings?view=' + this.calendar.fullCalendar('getView').type,
                        id : 'blocking-bookings-source',
                    });
                }else{
                    let event_source = this.calendar.fullCalendar('getEventSourceById', 'blocking-bookings-source');
                    event_source.url = '/app/user/' + this.user.id + '/blocking-bookings?view=' + this.calendar.fullCalendar('getView').type;
                    this.calendar.fullCalendar('refetchEventSources','blocking-bookings-source');
                }


            },

            addTeamMeetingEventSource() {
                if (typeof this.calendar.fullCalendar !== 'function') {
                    return;
                }

                if(!this.calendar.fullCalendar('getEventSourceById', 'teamMeetings')){
                    this.calendar.fullCalendar('addEventSource', {
                        id: 'teamMeetings',
                        events: this.fetchTeamMeetings,
                    });
                }
            },

            saveCalendarViewSetting(view_name) {
                if (last_saved_view[view_type] != view_name) {
                    if (view_type === 'mobile') {
                        http.post( "/app/settings/additional-settings", { calendar_view_mobile: view_name }).catch(() => {});
                    } else {
                        http.post( "/app/settings/additional-settings", { calendar_view_desktop: view_name }).catch(() => {});
                    }

                    last_saved_view[view_type] = view_name;
                }

                let view = this.calendar.fullCalendar('getView');
                this.$event_bus.$emit("emitView", view);
            },

            addIconToEventElement(element, icon_class, type = 'zmdi', statusName) {
                if (element.already_has_check_icon && icon_class === 'zmdi-check') {
                    return;
                }

                if (icon_class === 'zmdi-check') {
                    element.already_has_check_icon = true;
                }

                if (element.number_of_icons === 1) {
                    icon_class = icon_class + ' second-icon';
                }

                if (element.number_of_icons === 2) {
                    icon_class = icon_class + ' third-icon';
                }

                if (icon_class.includes('fas fa-arrows-rotate')) {
                    icon_class = icon_class + ' fa-spin';
                }

                if (icon_class.includes('fa-regular fa-calendar-circle-minus')) {
                    statusName = trans('calendar_blocking.blocking');
                }

                if (icon_class.includes('fa-regular fa-building')) {
                    statusName = trans('apps.team_meetings.title');
                }

                if (icon_class.includes('fa-regular fa-id-badge')) {
                    statusName = trans('apps.other_payers.contact_bookings.title');
                }

                if(BookingStatusSettings.systemStatuses.includes(statusName)) {
                    statusName = trans('modules.AppointmentStatus.booking_statuses.'+statusName);
                }

                if(icon_class.includes('fa-regular fa-calendar-exclamation')) {
                    statusName = trans('calendar.gcal_not_blocking');
                }

                icon_class = icon_class.replace('zmdi ', '');

                const bgColor = element.css('background-color');

                if (type === 'fa') {
                    element.find('.fc-content').prepend(`<i class="${icon_class}" title="${statusName}" style="background-color:${bgColor}; font-size:13px; top: 1px"></i>`);
                } else {
                    element.find('.fc-content').prepend(`<i class="${type} ${icon_class}" title="${this.getZmdiIconTooltipText(icon_class)}" style="background-color:${bgColor}"></i>`);
                }
                element.number_of_icons++;
            },

            getZmdiIconTooltipText(icon_class) {
                switch (true) {
                    case icon_class.includes('zmdi-check'):
                        return trans('calendar.icon_description.payment_complete');
                    case icon_class.includes('zmdi-time-interval'):
                        return trans('calendar.icon_description.partially_paid');
                    case icon_class.includes('zmdi-time'):
                        return trans('calendar.icon_description.easypay_scheduled');
                    case icon_class.includes('zmdi-file'):
                        return trans('invoice.create_success');
                    case icon_class.includes('zmdi-card-giftcard'):
                        return trans('calendar.icon_description.gift_card_added');
                    case icon_class.includes('zmdi-card'):
                        return trans('calendar.icon_description.easypay_payment');
                    case icon_class.includes('zmdi-alert-circle'):
                        return trans('online_payment.status_charge_failed_short');
                    case icon_class.includes('zmdi-alert-triangle'):
                        return trans('calendar.icon_description.requested_cancel');
                    case icon_class.includes('zmdi-accounts'):
                        return trans('events.event');
                    case icon_class.includes('zmdi-repeat'):
                        return trans('calendar.icon_description.event_recurring');
                    case icon_class.includes('zmdi-comment'):
                        return trans('calendar.icon_description.note_added');
                    default:
                        return '';
                }
            },

            addColumnMenuItemsToCalender(view) {
                let vm = this;

                // Dropdown menu
                let menu =
                    '<div class="dropdown calendar-column-dropdown" style="display:none;">' +
                        '<a href="" data-toggle="dropdown" data-target="#"> <i class="zmdi zmdi-more-vert"></i> </a>' +
                        '<ul class="dropdown-menu dropdown-menu-right" style="width:200px;"> ' +
                            // Menu Items will render inside here
                        '</ul>' +
                    '</div>';


                if (view.name === 'resourceView') {
                    $("#user-calendar th.fc-resource-cell").each(function (index, el) {
                        $(el).find("span .calendar-column-dropdown").remove();
                        $(el).append(menu);
                        let calendar_id = $(el).data('resource-id');

                        // Menu list Items which are appended to the Dropdown
                        let deleteButton = $('<li><a href="#" data-calendar-id="'+ calendar_id +'"><i class="zmdi zmdi-calendar-close m-r-5"></i>' + trans('calendar.bulk_deletion') + '</a></li>');
                        vm.deleteButtonHandler(view, $(deleteButton).find("a"));

                        // Append new menu items above here
                        $(el).find("ul").append(
                            deleteButton,
                        );
                    });
                }else{
                    $("#user-calendar th.fc-day-header").each(function (index, el) {
                        $(el).find("span .calendar-column-dropdown").remove();
                        $(el).append(menu);
                        let date = $(el).data('date');

                        // Menu list Items which are appended to the Dropdown
                        let deleteButton = $('<li><a href="#" data-date="'+ date +'"><i class="zmdi zmdi-calendar-close m-r-5"></i>' + trans('calendar.bulk_deletion') + '</a></li>');
                        vm.deleteButtonHandler(view, $(deleteButton).find("a"));

                        // Append new menu items above here
                        $(el).find("ul").append(
                            deleteButton,
                        );
                    });
                }
            },

            deleteButtonHandler(view, deleteButton) {
                deleteButton.on("click", (e) => {
                    e.preventDefault();

                    if (view.name === 'resourceView') {
                        this.$event_bus.$emit('showBulkCancel', undefined , undefined ,$(deleteButton).data('calendar-id'));
                    }else{
                        this.$event_bus.$emit('showBulkCancel', $(deleteButton).data('date'), $(deleteButton).data('date') , undefined);
                    }
                });
            },

            toggleNavigationButtons(enabled) {
                if (enabled) {
                    $('.fc-prev-button').removeClass('fc-state-disabled');
                    $('.fc-next-button').removeClass('fc-state-disabled');
                } else {
                    $('.fc-prev-button').addClass('fc-state-disabled');
                    $('.fc-next-button').addClass('fc-state-disabled');
                }
            },

            addColumnInformationToCalendar() {

                var view = this.calendar.fullCalendar('getView');

                if (this.is_waiting_list_active || this.is_booking_status_active) {

                    this.show_cancelled_bookings_on_these_dates = [];

                    http.get('/app/calendar/column-information', {
                            params: {
                                start: view.start.format('YYYY-MM-DD'),
                                end: view.end.format('YYYY-MM-DD'),
                                active_view :  view.type,
                            }
                        })
                        .then(({ data }) => {

                            $("#user-calendar .waiting-list-entries-link").remove();
                            this.applyWaitingListCountToDateLabels(data.waiting_list_entries);
                            this.applyCancelledBookingsCountToDateLabels(data.cancelled_booking_entries);

                        }).catch(() => {});
                }
            },

            applyWaitingListCountToDateLabels(data){
                var vm = this;

                forEach(data, (entry) => {
                    let html = $('<a href="" class="truncate waiting-list-entries-link">'+trans('waiting_list.calendar_day_cta', { count : entry.entries_count })+'</a>');
                    html.on("click", (e) => {
                        e.preventDefault();
                        let calendarId = entry.calendar_id

                        // If there is only one calendar with waiting list enabled default to it
                        if (!calendarId && this.activeCalendarsWithWaitingListEnabled.length === 1) {
                            calendarId = this.activeCalendarsWithWaitingListEnabled[0].id
                        }

                        const date_to_view = moment(entry.date, "YYYY-MM-DD").format('DD-MM-YYYY');
                        vm.$event_bus.$emit("showWaitingListModal", calendarId, date_to_view);
                    });

                    if(entry.calendar_id){
                        $("#user-calendar .fc-resource-cell[data-resource-id='"+entry.calendar_id+"'] .resource-title").append(html);
                    }else{
                        $("#user-calendar .fc-widget-header[data-date='"+entry.date+"']").append(html);
                    }

                });
            },

            applyCancelledBookingsCountToDateLabels(data) {
                let vm = this;
                var view = this.calendar.fullCalendar('getView');

                forEach(data, (entry) => {
                    let html = $('<a href="" class="truncate waiting-list-entries-link">'+transChoice('calendar.calendar_day_cta', entry.entries_count, { count : entry.entries_count })+'</a>');

                    html.on("click", (e) => {
                        e.preventDefault();

                        if (view.type == 'resourceView') {
                            if (includes(vm.show_cancelled_bookings_on_these_calendars, entry.calendar_id)) {
                                remove(vm.show_cancelled_bookings_on_these_calendars, n => n === entry.calendar_id);
                                $(e.target).text(transChoice('calendar.calendar_day_cta', entry.entries_count, { count : entry.entries_count }));
                            } else {
                                vm.show_cancelled_bookings_on_these_calendars.push(entry.calendar_id);
                                $(e.target).text(transChoice('calendar.calendar_day_hide_cta', entry.entries_count, { count : entry.entries_count }));
                            }
                        } else {
                            if (includes(vm.show_cancelled_bookings_on_these_dates, entry.date)) {
                                remove(vm.show_cancelled_bookings_on_these_dates, n => n === entry.date);
                                $(e.target).text(transChoice('calendar.calendar_day_cta', entry.entries_count, { count : entry.entries_count }));
                            } else {
                                vm.show_cancelled_bookings_on_these_dates.push(entry.date);
                                $(e.target).text(transChoice('calendar.calendar_day_hide_cta', entry.entries_count, { count : entry.entries_count }));
                            }
                        }

                        vm.updateEventSourceForBookings();
                        vm.reloadCalendar();
                    });

                    if (entry.calendar_id) {
                        $("#user-calendar .fc-resource-cell[data-resource-id='"+entry.calendar_id+"'] .resource-title").append(html);
                    } else {
                        $("#user-calendar .fc-widget-header[data-date='"+entry.date+"']").append(html);
                    }

                });
            },

            handleEventSourceError(error) {
                if (error.status == 401) {
                    this.$event_bus.$emit('unauthenticated');
                }
            },

            getEvents(start, end, callback) {
                this.loading = true;

                let startDate = start.format('YYYY-MM-DD');
                let endDate = end.format('YYYY-MM-DD');

                this.cancellationSource.cancel();
                this.cancellationSource = axios.CancelToken.source();

                let bookingsPromise = http.get(
                    this.bookingsEventSourceUrl, {
                        params: { start: startDate, end: endDate },
                        cancelToken: this.cancellationSource.token,
                    })
                    .then(response => {
                        return response.data;
                    }).catch(error => {
                        if (!axios.isCancel(error)) {
                            this.handleEventSourceError(error);
                        }
                    });

                let openingTimesPromise = http.get('/app/calendar/opening-times', {
                        params: { start: startDate, end: endDate },
                        cancelToken: this.cancellationSource.token,
                    })
                    .then(response => {
                        return response.data;
                    }).catch(error => {
                        if (!axios.isCancel(error)) {
                            this.handleEventSourceError(error);
                        }
                    });

                let eventsPromise = this.is_events_active ? http.get('/app/event', {
                        params: { start: startDate, end: endDate },
                        cancelToken: this.cancellationSource.token,
                    })
                    .then(response => {
                        return response.data;
                    }).catch(error => {
                        if (!axios.isCancel(error)) {
                            this.handleEventSourceError(error);
                        }
                    }) : Promise.resolve([]);

                let googleCalendarPromise = this.should_pull_from_google_calendar ? http.get('/app/app/google-calendar', {
                    params: {
                        start: start.toISOString(),
                        end: end.toISOString(),
                        _: (new Date()).getTime(),
                    },
                    cancelToken: this.cancellationSource.token,
                })
                    .then(({ data }) => {
                        return data;
                    }).catch((error) => {
                        if (!axios.isCancel(error)) {
                            return [];
                        }
                    }) : Promise.resolve([]);

                let waitingListPromise = this.is_waiting_list_active ? http.get('/app/waiting-list/invitations/range', {
                        params: { start: startDate, end: endDate },
                        cancelToken: this.cancellationSource.token,
                    })
                    .then(response => {
                        return response.data;
                    }).catch((error) => {
                        if (!axios.isCancel(error)) {
                            this.handleEventSourceError(error);
                        }
                    }) : Promise.resolve([]);

                let holidaysPromise = Promise.resolve([]);
                if (this.show_holidays) {
                    let startYear = start.format('YYYY');
                    let endYear = end.format('YYYY');
                    let yearsToFetch = {start: false, end: false};

                    if (this.publicHoliday.retrievedYears.indexOf(startYear) === -1) {
                        yearsToFetch.start = startYear;
                        this.publicHoliday.retrievedYears.push(startYear);
                    }
                    if (this.publicHoliday.retrievedYears.indexOf(endYear) === -1) {
                        yearsToFetch.end = endYear;
                        this.publicHoliday.retrievedYears.push(endYear);
                    }

                    if (yearsToFetch.start || yearsToFetch.end) {
                        holidaysPromise = http.get('/app/public_holidays', {
                            params: {
                                start: yearsToFetch.start ? yearsToFetch.start : yearsToFetch.end,
                                end: yearsToFetch.end ? yearsToFetch.end : yearsToFetch.start
                            },
                            cancelToken: this.cancellationSource.token,
                        })
                            .then(({ data }) => {
                                this.publicHoliday.holidays = union(this.publicHoliday.holidays, data);

                                return data;
                            }).catch(() => {});
                    } else {
                        holidaysPromise = Promise.resolve(this.publicHoliday.holidays);
                    }
                }

                let contactBookingsPromise = this.is_other_payers_active ? http.get('/app/contacts/bookings', {
                    params: { start: startDate, end: endDate },
                    cancelToken: this.cancellationSource.token,
                })
                    .then(({ data }) => data)
                    .catch(() => {}) : Promise.resolve([]);

                Promise.all([
                    bookingsPromise,
                    openingTimesPromise,
                    eventsPromise,
                    googleCalendarPromise,
                    waitingListPromise,
                    holidaysPromise,
                    contactBookingsPromise,
                ]).then(results => {
                    if (results.includes(undefined)) {
                        return;
                    }

                    callback(results.flat());
                    this.loading = false;
                });
            },

            printCalendar() {
                var view = this.calendar.fullCalendar('getView');

                http.get('/app/calendar/print', {
                        params: {
                            start: view.start.format('YYYY-MM-DD'),
                            end: view.end.format('YYYY-MM-DD')
                        }
                    })
                    .then(({ data }) => {
                        this.printHtml(data);
                    }).catch((error) => {
                        console.log(error);
                        swal(trans('global.error_title'), trans('global.error'), "warning");
                });
            },

            reloadCalendar() {
                $('#user-calendar').fullCalendar( 'refetchEvents' );
            },

            moveEvent(event, reloadCalendar = true) {
                eventService.moveEvent(event)
                    .then(({data}) => {
                        if (reloadCalendar) {
                            this.$event_bus.$emit('calendarReload');
                        }
                    });
            },

            moveBooking(booking, revertFunction) {
                if (booking.recurring_booking_group_id && booking.type === 'client_booking') {
                    this.$event_bus.$emit('showMoveRecurringBookingModal', { booking, revertFunction });
                } else {
                    http.post(`/app/booking/${booking.id}/move`, {
                            start: booking.start.format('YYYY-MM-DD HH:mm:ss'),
                            end: booking.end.format('YYYY-MM-DD HH:mm:ss'),
                        })
                        .then(({ data }) => {
                            if (booking.type == 'client_booking') {
                                this.$event_bus.$emit('openBookingUpdatetModal', data.booking);
                                this.$event_bus.$emit('bookingTimeUpdated', data.booking);
                            }

                            toastr.success(data.success);

                            this.$event_bus.$emit('refreshTaskList');
                        })
                        .catch(({ error, errorBag }) => {
                            revertFunction();

                            if (errorBag) this.$setErrorBag(errorBag);

                            if (errorBag && errorBag.has('helfo')) {
                                swal({
                                    title: trans('global.error_title'),
                                    text: errorBag.first('helfo'),
                                    closeOnConfirm: true,
                                });
                            } else {
                                setTimeout(() => {
                                    swal(trans('global.error_title'), trans('global.error'), 'warning');
                                }, 500)
                            }
                        });
                }
            },

            moveTeamMeeting(meeting, revertFunction) {
                if ( meeting.recurring ) {
                    this.$event_bus.$emit('showMeetingRecurringModal',  meeting, 'move', revertFunction);
                    return
                }

                moveTeamMeetingRequest(meeting, revertFunction);
            },

            moveContactBooking(booking, revertFunction) {
                if (booking.recurring) {
                    this.$event_bus.$emit('showRecurringContactBookingModal', booking, 'move', revertFunction);
                    return;
                }

                moveContactBookingRequest(booking, revertFunction);
            },

            toggleCalendarLoader(toggle) {
                if(toggle){
                    $("#user-calendar .fc-right .preloader").remove();
                    var preloader_elem = $("<div class='preloader'></div>");
                    $("#user-calendar .fc-right").append(preloader_elem);
                }else{
                    $("#user-calendar .fc-right .preloader").remove();
                }
            },

            triggerCalendarViewOption() {

                var window_width = $(window).width();

                if(!this.loading){

                    if (window_width >= 768 && view_type !== "desktop") {
                        this.calendar.fullCalendar('changeView', this.calendar_view_desktop);
                        view_type = "desktop";
                    }

                    if (window_width < 768 && view_type !== 'mobile') {
                        this.calendar.fullCalendar('changeView', this.calendar_view_mobile);
                        view_type = "mobile";
                    }

                }

            },

            getDefaultView() {
                var default_view =  this.calendar_view_desktop;
                var window_width = $(window).width();

                if (window_width >= 768 && view_type !== "desktop") {
                    default_view =  this.calendar_view_desktop;
                    view_type = "desktop";
                }

                if (window_width < 768 && view_type !== 'mobile') {
                    default_view =  this.calendar_view_mobile;
                    view_type = "mobile";
                }

                return default_view;
            },
            getParameterByName(name) {
                return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(name).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
            },
            isOtherBooking() {
                return Boolean(this.getParameterByName('otherBooking'));
            },

            async fetchBooking (bookingId) {
                /*
                ** This is only used when we are opening a booking modal (event / event course / appointment) from a link in the system
                ** I checked and to open an appointment modal, the only thing required is the booking id
                ** But to open an event modal, we need the event id and the cal_id too, which we aren't sending in the URL params.
                **
                ** 1. So for the appointment we are not fetching the booking first, we will just pass the { id: <ID> } to the openBookingModal() method
                ** 2. For the event, we are fetching the event booking first, and then passing the whole event object to the openBookingModal() method
                */
                try {
                    this.loading = true

                    let booking = {
                        id: bookingId,
                        other: this.isOtherBooking(),
                        type: 'client_booking' // this is only used for the appointment booking modal
                    };

                    if (this.getParameterByName('event') === '1') { // checks if the url has event parameter set to 1
                        const res = await http.get(`/app/event/${bookingId}`);
                        booking = res.data;
                    }

                    this.openBookingModal(booking); // open the modal
                } catch (error) {
                    console.log(error);
                } finally {
                    this.loading = false
                }
            },

            async fetchMeeting (meetingId) {
                try {
                    this.loading = true

                    const res = await http.get(`/app/team-meetings/meetings/${meetingId}`);
                    this.$event_bus.$emit('showTeamMeetingModal', res.data);
                } finally {
                    this.loading = false
                }
            },

            indicatePatientTravelInfo(booking, element) {
                if (!booking.client) {
                    return
                }

                if (this.bookingHasRequisitions(booking)) {
                    this.buildIcon(element, {
                        class: 'fa fa-route',
                        title: trans('modules.PatientTravel.created'),
                    })
                }

                if (
                    this.bookingRequiresTravelRequisition(booking)
                    && this.canCreateRequisitionsForBooking(booking)
                ) {
                    this.buildIcon(element, {
                        class: 'fa fa-exclamation-circle',
                        title: trans('modules.PatientTravel.client_requires'),
                    })
                }
            },

            buildIcon(element, attrs) {
                if (!('style' in attrs)) {
                    attrs.style = this.getIconDefaultStyles(element)
                }
                attrs.class = this.buildIconCssClasses(element, attrs.class)

                let attrsList = Object.entries(attrs).map(a => `${a[0]}="${a[1]}"`)
                element.find('.fc-content')
                    .prepend('<i ' + attrsList.join(' ') + '></i>');
            },

            getIconDefaultStyles(element) {
                let styles = ['font-size:12px']
                styles.push('background-color:' + element.css('background-color'))
                return styles.join('; ')
            },

            buildIconCssClasses(element, cssClass) {
                let classes = [cssClass]

                // TODO: Hack, due to addIconToEventElement not reusable
                if (element.number_of_icons === 1) {
                    classes.push('second-icon')
                }

                if (element.number_of_icons === 2) {
                    classes.push('third-icon')
                }

                element.number_of_icons++

                return classes.join(' ')
            },

            async fetchContactBooking (bookingId) {
                try {
                    this.loading = true
                    const res = await http.get(`/app/contacts/bookings/${bookingId}`);
                    this.$event_bus.$emit('showContactBookingModal', res.data);
                } finally {
                    this.loading = false
                }
            },

            addInvoiceIconsToContactBooking(booking, element) {
                if (booking.className.indexOf('payed') > -1) {
                    this.addIconToEventElement(element, 'zmdi-check');
                } else {
                    this.addIconToEventElement(element, 'zmdi-file');
                }
            },

            highlightActiveBooking(bookingId) {
                // Clear any existing highlights first
                this.removeAllHighlights();
                
                if (bookingId) {
                    const element = document.querySelector(`.booking-${bookingId}`);
                    if (element) {
                        element.classList.add('sidebar-active-event');
                    }
                }
            },
            
            removeAllHighlights() {
                // Remove the highlight class from any elements that have it
                const highlightedElements = document.querySelectorAll('.sidebar-active-event');
                highlightedElements.forEach(element => {
                    element.classList.remove('sidebar-active-event');
                });
            },

            getActiveBookingId() {
                if (this.calendarSidebarStore.currentParams?.bookingId) {
                    return this.calendarSidebarStore.currentParams.bookingId;
                }
                
                if (this.calendarSidebarStore.currentParams?.booking?.id) {
                    return this.calendarSidebarStore.currentParams.booking.id;
                }
                
                return null;
            },

            hasParameter(param) {
                return this.getParameterByName(param) !== '';
            },

            async handleCalendarsLoaded() {
                this.$nextTick(async () => {
                    if (this.hasParameter('newbooking')) {
                        this.calendarSidebarStore.navigateTo(SidebarViews.CREATE_CLIENT_BOOKING, { booking: {}, mode: 'new_booking' });
                    }
                    if (this.hasParameter('copy_booking')) {
                        this.calendarSidebarStore.navigateTo(SidebarViews.CREATE_CLIENT_BOOKING, { booking: {}, mode: 'copy_booking' });
                    }
                });
            },
        },

        watch: {
            showJournal (value) {
                if (!value) {
                    this.selectedBooking = null
                }
            },
            has_waiting_list(value) {
                if(value) {
                    this.$event_bus.$emit('showWaitingListButton');
                } else {
                    this.$event_bus.$emit('hideWaitingListButton');
                }
            },
            can_edit_calendars(value) {
                this.calendar.fullCalendar('option', 'selectable', value);
            },
            loading(value) {
                if (value) {
                    this.toggleCalendarLoader(true);
                } else {
                    this.toggleCalendarLoader(false);
                }
            },
            active_view(value, oldValue) {

                if(this.has_calendar_blocking_rules_created) {

                    //Only update event source for blocking booking if switching to resource view from other view.
                    if(value !== oldValue && value === 'resourceView'){
                        this.updateEventSourceForBookingBlocking();
                    }

                    //Only update event source for blocking booking if switching from resource view to other view.
                    if(value !== oldValue && oldValue === 'resourceView'){
                        this.updateEventSourceForBookingBlocking();
                    }

                    //If oldvalue is null, it means that the calendar has just been initialized. So we need to update the event source for blocking booking.
                    if(!oldValue){
                        this.updateEventSourceForBookingBlocking();
                    }

                }
            },
            'calendarSidebarStore.currentParams': function(value) {
                if (value?.bookingId) {
                    this.highlightActiveBooking(value.bookingId);
                } else if (value?.booking?.id) {
                    this.highlightActiveBooking(value.booking.id);
                } else {
                    this.removeAllHighlights();
                }
            },
            'calendarSidebarStore.isOpen': function(isOpen) {
                if (!isOpen) {
                    this.removeAllHighlights();
                }
            }
        }
    };
</script>

<template id="calendar">
    <div class="calendar-wrap notranslate" :class="{ 'blur-me' : is_blurred }">

        <div :class="'calendar calendar_interval_' + user.calendar_interval" id="user-calendar"></div>

        <floatable-dropdown
            ref="contextMenu"
        >
            <client-booking-dropdown-actions
                v-if="selectedContextMenu === contextMenus.clientBooking"
                v-bind="contextMenuProps"
                :calendar_sidebar_enabled="calendar_sidebar_enabled"
                @option-selected="resetContextMenu"
                @show-journal="viewJournal">
            </client-booking-dropdown-actions>

            <calendar-dropdown-actions
                v-else-if="selectedContextMenu === contextMenus.calendar"
                v-bind="contextMenuProps"
                @option-selected="resetContextMenu"
                :on_tour="on_tour"
                :calendar_sidebar_enabled="calendar_sidebar_enabled">
            </calendar-dropdown-actions>

        </floatable-dropdown>

        <div id="print-div"></div>

        <transition name="slide">

            <div class="rebook-appointment-wrap bottom-popup" v-if="copying_booking">

                <div class="m-0 panel panel-color panel-inverse">
                    <div class="panel-heading">
                        <button type="button" class="close" @click.prevent="copying_booking = false">×</button>
                        <h3 class="panel-title"><span><i class="zmdi zmdi-forward m-r-5"></i> {{ trans('calendar.copy_booking') }}</span></h3>
                    </div>

                    <div class="rebook-appointment-content bottom-popup-content">

                        <div class="m-t-15">
                            {{ trans('calendar.copy_booking_help_text') }}
                            <span v-if="copying_booking.clientid > 0
                                ? $can('see-client', copying_booking.client) || can_see_unassigned_client_names
                                : $can('see-clientgroup', copying_booking.client_group || can_see_unassigned_client_names)"
                            >
                                {{ copying_booking.clientid > 0 ? copying_booking.client.name : copying_booking.client_group.name }}
                            </span>
                            <span v-else v-blur>{{ trans('clients.unknown_client') }}</span>

                            <!-- Button to open Quick Booking Modal -->
                            <div v-if="is_online_booking_active" class="text-right mt-2">
                                <ep-button
                                    variant="secondary"
                                    class="rounded px-4 py-2"
                                    @click="openQuickBooking"
                                >
                                    {{ trans('online_booking.quick_booking.find_time') }}
                                </ep-button>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

        </transition>

        <move-recurring-booking-modal></move-recurring-booking-modal>

        <modal v-model="showJournal" size="full" data-backdrop="static" data-keyboard="false" :noPadding="true">

            <template #title>
                <i class="zmdi zmdi-book m-r-10"></i>
                <span v-if="showJournal">{{ trans('calendar.journal_for') }} {{ selectedBooking.client.name }}</span>
            </template>

            <client-journal
                v-if="showJournal"
                :client-or-group="selectedBooking.client ? selectedBooking.client : selectedBooking.client_group"
                :is-group-journal="!!selectedBooking.client_group"
                :main_journal="0"
                :sort_order_initial="journal_sort_setting">
            </client-journal>
        </modal>

        <team-meeting-detail-modal v-if="is_team_meetings_active" />
        <team-meeting-form-modal v-if="is_team_meetings_active" />
        <recurring-team-meeting-adjustment-modal v-if="is_team_meetings_active" />

        <contact-booking-detail-modal v-if="is_other_payers_active" />
        <create-contact-booking v-if="is_other_payers_active && can_see_clients" />
        <create-contact-booking-no-access v-if="is_other_payers_active && !can_see_clients" />
        <recurring-contact-booking-adjustment-modal v-if="is_other_payers_active" />

        <div v-if="is_surveys_enabled && calendar_sidebar_enabled">
            <add-survey-to-booking-modal :can-send-sms-messages="canSendSmsMessages" :survey-settings="surveySettings"></add-survey-to-booking-modal>
        </div>

        <!-- Quick Booking Modal -->
        <quick-booking
            v-if="showQuickBooking"
            :copied-booking="quickBookingData"
            :calendar_sidebar_enabled="calendar_sidebar_enabled"
            @cancel="showQuickBooking = false">
        </quick-booking>
    </div>
</template>
